import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity from "entity";

export default class Variedade extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/tchVariedadeCanaList01/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("variedade");
    }

    async initialize() {
        this.data.status = "ATIVO";
    }

    static get labelField() {
        return "variedade";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 1, filter: true },
            {
                field: "status",
                headerName: "Status",
                flex: 1,
                filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO"]),
            },
            { field: "variedade", headerName: "Variedade", flex: 2, filter: true },
        ];
    }
}
